import { render, staticRenderFns } from "./ListBnDeplac.vue?vue&type=template&id=b0108fee&scoped=true&"
import script from "./ListBnDeplac.vue?vue&type=script&lang=js&"
export * from "./ListBnDeplac.vue?vue&type=script&lang=js&"
import style0 from "./ListBnDeplac.vue?vue&type=style&index=0&id=b0108fee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0108fee",
  null
  
)

export default component.exports